import { render, staticRenderFns } from "./threejs5.vue?vue&type=template&id=3969514a&scoped=true"
import script from "./threejs5.vue?vue&type=script&lang=js"
export * from "./threejs5.vue?vue&type=script&lang=js"
import style0 from "./threejs5.vue?vue&type=style&index=0&id=3969514a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3969514a",
  null
  
)

export default component.exports